export const APP_THEMES = ["light", "dark", "retro", "neon"] as const;

export type AppTheme = (typeof APP_THEMES)[number];

/** Where the chosen theme is kept in the browser. */
export const THEME_STORAGE_KEY = "app.theme";

export const DEFAULT_APP_THEME: AppTheme = "light";

export function isAppTheme(value: string | null | undefined): value is AppTheme {
  return APP_THEMES.includes((value || "") as AppTheme);
}
